import './themes/generated/theme.additional.css';
import './utils/devExtreme.js'
import Vue from "vue";
import App from "./App";
import router from "./router";
import appInfo from "./app-info";
import store from './store'
import * as http from './request/http.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import address from './request/url.js'
import websocket from "@/utils/websocket";

Vue.prototype.$address= address.ip;
Vue.prototype.$websocket= websocket;
Vue.config.productionTip = false;
Vue.prototype.$appInfo = appInfo;
Vue.prototype.$http = http;
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
